import React, { useState } from 'react'

import CopyToClipBoard from 'react-copy-to-clipboard'
import { Grid, Header, Button, Label } from 'semantic-ui-react'

import { IProject } from '../../../api/Data'

import ExternalLink from '../../../components/common/ExternalLink'

const CollaborateTab = ({ project }: IProps) => {
  // States
  const [copied, setCopied] = useState(false)

  if (!project) return null

  const { projectUrl } = project

  const embedCode = `<iframe src=${projectUrl} type="text/html" width="100%" height="1000"></iframe>`

  return (
    <div style={{ textAlign: 'center' }}>
      <Header as="h2" style={{ fontWeight: 'bold' }}>
        By embedding on your website
      </Header>
      
      <Grid columns={1} verticalAlign="middle" stackable>
        <Grid.Column>
          <Header as="h4">
            <Header.Subheader>
              Copy this code snippet directly on your landing page or micro site to allow your audience to contribute their videos directly form your website.
            </Header.Subheader>
          </Header>
        </Grid.Column>

        <Grid.Column>
          <CopyToClipBoard
            text={embedCode}
            options={{ format: 'text/plain' }}
            onCopy={() => {
              setCopied(true)
            }}
          >
            <Button as="div" labelPosition="left">
              <Label as="a" basic>
                {`${embedCode.slice(0, 20)}...`}
              </Label>
              <Button compact icon primary>
                {copied ? 'Copied' : 'Copy code'}
              </Button>
            </Button>
          </CopyToClipBoard>
        </Grid.Column>

        <Grid.Column>
          <ExternalLink url="https://vloggi.com/docs/embedding-the-vloggi-video-submission-widget-on-your-website/">Read more</ExternalLink>
        </Grid.Column>
      </Grid>
    </div>
  )
}

interface IProps {
  project: IProject
}

export default CollaborateTab
